import { isC3Experience } from "../../../../../shared/util/C3Utils";
define((require) => {
    "use strict";

    const ReactBridge                   = require("backbone.react-bridge");
    const ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView");
    const AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView");
    const CompactImageLibraryView       = require("ui/editor/imageLibrary/CompactImageLibraryView");
    const EditorEvents                  = require("shared/services/EditorEvents");
    const ImageCollection               = require("data/ImageCollection");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const StylePropertiesView           = require("ui/experience/widgets/StylePropertiesView");
    const template                      = require("ui/experience/widgets/imageWidget/ImageWidgetPropertiesView.tpl");
    const AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");
    const EditorEventFilters            = require("ui/editor/EditorEventFilters").default;
    const C3ImageLibrary                = require("ui/editor/imageLibrary/C3ImageLibrary").default;

    const EXPAND_PROPERTY = "imageLibraryExpanded";
    var folderState={
        folderPathDetails: "/",
        accordianTitleDetails: "Select folder"
    }

    /**
     * The properties view for an image widget.
     *
     * @class ImageWidgetPropertiesView
     * @constructor
     *
     * @cfg {ImageWidgetModel} model The model for the image widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("ImageWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template,

        ui: {
            container: ".image-properties-accordion",
            legend:    "[data-target=\".image-properties-accordion\"]"
        },

        regions: {
            imageLibraryRegion:        ".image-properties-accordion",
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties:           ".style-properties",
            analyticsProperties:       ".analytics-properties",
            animationProperties:       ".animation-properties",
            actionProperties:          ".action-properties"
        },

        _handleImageClick(imageModel) {
            console.log(imageModel);
            const properties = {
                altText: imageModel.altText,
                imageId: imageModel.imageId,
                originalImageHeight: imageModel.height,
                originalImageWidth: imageModel.width,
                src: imageModel.url
            };

            this.model.set(properties);

            const eventProperties = {
                triggerOrigin: "ImageLibrary",
                imageId: imageModel.imageId,
                imageName: imageModel.name,
                projectId: project && project.get("id")
            };

            const experience = this.viewScope.viewModel.get("experience");

            if (experience) {
                eventProperties.experienceId = experience.get("id");
                eventProperties.experienceVersion = experience.get("version");
                eventProperties.experiencePushedVersion = experience.get("pushedVersion");
            }
            // Make sure we log the event
            EditorEvents.trigger(EditorEvents.constants.SELECT_IMAGE, eventProperties);
        },

        _showCompactLibrary() {
            const {viewModel} = this.viewScope;
            const imageLibrarySorting = viewModel.get("imageLibrarySorting");
            const collection = new ImageCollection();
            const project = viewModel.get("project");

            const imageLibrary = new CompactImageLibraryView({
                collection,
                selectedImage: this.model && this.model.get("imageId") ? this.model : null,
                imageLibrarySorting,
                project,
                itemViewOptions: {
                    imageTaggingEnabled: viewModel.get("imageTaggingEnabled"),
                    inventoryEnabled: viewModel.get("inventoryEnabled"),
                    draggable: true
                }
            });

            this.listenTo(imageLibrary, "image:selected", (imageModel) => {
                // Change content of imageWidget
                const properties = {
                    altText:             imageModel.get("altText"),
                    imageId:             imageModel.get("id"),
                    originalImageHeight: imageModel.get("height"),
                    originalImageWidth:  imageModel.get("width"),
                    supportsResize:      imageModel.get("supportsResize"),
                    src:                 imageModel.get("url")
                };

                this.model.set(properties);

                const eventProperties = {
                    triggerOrigin: "ImageLibrary",
                    imageId: imageModel.get("id"),
                    imageName: imageModel.get("name"),
                    projectId: project && project.get("id"),
                    sourceType: imageModel.get("sourceType")
                };

                const experience = this.viewScope.viewModel.get("experience");

                if (experience) {
                    eventProperties.experienceId = experience.get("id");
                    eventProperties.experienceVersion = experience.get("version");
                    eventProperties.experiencePushedVersion = experience.get("pushedVersion");
                }
                // Make sure we log the event
                EditorEvents.trigger(EditorEvents.constants.SELECT_IMAGE, eventProperties);
            });

            this.model.set("selectedWidgetId", this.model.get("uuid"), {cause: EditorEventFilters.SUPERFICIAL});
            this.imageLibraryRegion.show(imageLibrary);
        },
        _handleDragStart(path, title){
            folderState.folderPathDetails=path;
            folderState.accordianTitleDetails=title;
        },

        _showC3ImageLibrary() {
            this.model.set("selectedWidgetId", this.model.get("uuid"), {cause: EditorEventFilters.SUPERFICIAL});

            this.imageLibraryRegion.show(ReactBridge.viewFromComponent(C3ImageLibrary,
                {
                props: {handleImageClick: this._handleImageClick.bind(this),handleDragStart: this._handleDragStart.bind(this),folderPath: folderState.folderPathDetails,accordianTitle: folderState.accordianTitleDetails}
            }));
        },

        onRender() {
            this.__super();

            if (isC3Experience())
                this._showC3ImageLibrary();
            else
                this._showCompactLibrary();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({model: this.model, editorViewModel: this.viewScope.viewModel, widgetView: this.options.widgetView}));
            this.styleProperties.show(new StylePropertiesView({model: this.model, hideOpacityControls: true, hideRadiusControls: true}));
            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.actionProperties.show(new ActionPropertiesView({model: this.model}));
        },

        _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.hasImage();
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/imageWidget/ImageWidgetPropertiesView.js